module.exports = __webpack_public_path__ + "static/img/华为 HUAWEI FreebudsPro3.00361318.png";